
import { defineComponent, PropType } from 'vue';
import { IElForm } from '@/types/element';
import { IExtension } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/extensions';

export default defineComponent({
  emits: ['cancel', 'submit'],
  props: {
    extension: {
      type: Object as PropType<IExtension>,
      required: true,
    },
  },
  data() {
    return {
      form: { ...this.extension },
    };
  },
  methods: {
    apiSubmit() {
      api.setTags(this.form, (res) => {
        if (!res) return;

        utils.success('插件标签设置成功！');
        this.$emit('submit', this.form);
      });
    },

    btnCancelClick() {
      this.$emit('cancel');
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.apiSubmit();
        }
      });
    },
  },
  watch: {
    extension(value) {
      this.form = { ...value };
    },
  },
});
